import { useState } from "react";
import { IRONMAN_EVENTS, loadIronManResults, saveIronManResult, IronManResults } from "./ironmanTest";
import "./IronManPanel.scss";

/**
 * Per-event targeting for the Svenska Skidförbundet IronMan fystest (senior).
 * Shows the 8 events, the capacity each measures and the sessions that develop
 * it, and lets the athlete record current + target per event (localStorage).
 * The capacity engine (capacityPlan.ts) trains all eight; this makes the
 * targeting visible and trackable. Official point tables = a later add.
 */
export function IronManPanel() {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState<IronManResults>(() => loadIronManResults());

  const tracked = IRONMAN_EVENTS.filter(e => results[e.id]?.current || results[e.id]?.target).length;

  const update = (id: string, field: "current" | "target", value: string) =>
    setResults(saveIronManResult(id, field, value));

  return (
    <section className="imp">
      <button className={`imp__toggle${open ? " imp__toggle--open" : ""}`} onClick={() => setOpen(o => !o)} aria-expanded={open}>
        <span className="imp__toggle-caret">{open ? "▾" : "▸"}</span>
        IronMan-test (8 moment)
        <span className="imp__toggle-hint">{tracked > 0 ? `${tracked}/8 spårade` : "Svenska Skidförbundet"}</span>
      </button>

      {open && (
        <div className="imp__body">
          <p className="imp__intro">
            Svenska Skidförbundets fystest. Planen tränar alla åtta moment, periodiserat. Fyll i ditt
            senaste resultat och ett mål per moment för att följa utvecklingen. Skapa ett
            <strong> IronMan-test</strong>-mål i loppväljaren för att toppa mot ett testdatum.
          </p>

          <ol className="imp__list">
            {IRONMAN_EVENTS.map((e, i) => (
              <li key={e.id} className="imp__row">
                <div className="imp__row-head">
                  <span className="imp__num">{i + 1}</span>
                  <span className="imp__name">{e.name}</span>
                  <span className="imp__cap">{e.capacity}</span>
                </div>
                <div className="imp__trained">Tränas av: {e.trainedBy}</div>
                <div className="imp__inputs">
                  <label className="imp__field">
                    Nu
                    <input
                      className="imp__input" placeholder={e.unit}
                      value={results[e.id]?.current ?? ""}
                      onChange={ev => update(e.id, "current", ev.target.value)}
                    />
                  </label>
                  <label className="imp__field">
                    Mål
                    <input
                      className="imp__input" placeholder={e.unit}
                      value={results[e.id]?.target ?? ""}
                      onChange={ev => update(e.id, "target", ev.target.value)}
                    />
                  </label>
                  <span className="imp__unit">{e.unit}{e.higherIsBetter ? " · mer = bättre" : " · lägre = bättre"}</span>
                </div>
              </li>
            ))}
          </ol>

          <p className="imp__footnote">
            Resultat sparas lokalt. Officiella poängtabeller (senior) finns i testprotokollet och kan läggas till senare.
          </p>
        </div>
      )}
    </section>
  );
}
